import { INPUT_HEIGHT, INPUT_LINE_HEIGHT, prefixClassName } from "@smartrr/shared/components/primitives";
import cn from "classnames";
import styled from "styled-components";

export const SelectWrapper = styled.label.attrs(props => ({
  className: cn(props.className, prefixClassName("select-wrapper")),
}))<{ noBorder?: boolean; disabled?: boolean }>`
  cursor: pointer;
  position: relative;
  display: inline-flex;
  align-items: stretch;
  ${props =>
    props.noBorder
      ? ""
      : `
  `}

  ${props =>
    !props.noBorder &&
    `
    min-height: ${INPUT_HEIGHT}px;
    border-style: solid;
    border-radius: ${props.theme.dropdown?.borderRadius};
    border-width: ${props.theme.dropdown?.borderWidth};
    border-color: ${props.theme.dropdown?.borderColor};
  `}

  ${props =>
    props.noBorder &&
    `
    border-bottom: 1px solid ${props.theme.dropdown?.borderColor};
  `}

  background-color: ${props => props.theme.dropdown?.backgroundColor};

  margin: 0;
  font-family: ${props => props.theme.body?.fontFamily};
  flex: 1;

  ${props =>
    props.disabled &&
    `
    opacity: 0.5;
    cursor: default;
  `}

  &::after {
    pointer-events: none;
    cursor: pointer;
    content: "";
    font-size: 16px;
    padding-right: 10px;
    text-align: right;
    position: absolute;
    right: ${props => (props.noBorder ? 4 : 10)}px;
    top: 50%;
    text-rendering: optimizeLegibility;
    box-sizing: content-box;

    border: solid ${props => props.theme.dropdown?.color || "inherit"};
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    margin-top: ${props => (props.noBorder ? -6 : -5)}px;
    transform: rotate(45deg) translateY(-50%);
    -webkit-transform: rotate(45deg);
  }
`;

export const StyledSelect = styled.select.attrs({
  className: prefixClassName("select"),
})<{ noBorder?: boolean }>`
  box-sizing: border-box;
  width: 100%;
  margin: 0 !important;
  color: ${props => props.theme.dropdown?.color || "inherit"};
  font-family: ${props => props.theme.dropdown?.fontFamily};
  font-weight: ${props => props.theme.dropdown?.fontWeight};
  border: 0;
  ${props => !props.noBorder && `line-height: ${INPUT_LINE_HEIGHT * 1.25}px;`}

  ${props =>
    props.noBorder
      ? `
  border: none;
  padding-top: 0;
  padding-bottom: 3px;
  padding-left: 0;
  padding-right: 30px;
`
      : `
  padding: 0 2rem 0 1rem;
`}

  cursor: pointer;
  outline: none;
  appearance: none;
  border: none;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background-color: transparent;
  position: relative;
  z-index: 1;
  background-image: none;

  &[disabled] {
    background-color: unset;
    border-color: unset;
  }

  &:focus {
    border: none;
    outline: none;
  }
`;
